import { render, staticRenderFns } from "./CenterTemplate.vue?vue&type=template&id=527fa68b&"
import script from "./CenterTemplate.vue?vue&type=script&lang=js&"
export * from "./CenterTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports